import PostingPlanConfiguration from './PostingPlanConfiguration'

export default PostingPlanConfiguration
